<template>
  <!-- APP ACTIVO -->
  <!-- ES LA VERSION DESDE APP LOS COMPONENTES Y CAMBIOS DE RUTAS -->
  <v-app color="primary">
    <!-- HEADER -->
    <navbar>
      <template v-slot:left>
        <v-container class="pl-1 hidden-sm-and-down" style="width: 295px;">
          <a href="https://intraug.ugto.mx/Usuario/ListadoServicios">
            <v-img width="295" :src="require('@/assets/intraug.png')" alt="logo" />
          </a>
        </v-container>

        <!-- TITULO CABECERA -->
        <v-toolbar-title
        class="headline hidden-sm-and-down text-center mr-12 pr-12"
        style="width: 100%;"
        >
        <span
          class="font-weight-light white--text mr-12 pr-12"
          >Encuestas Institucionales UG</span
        >
        </v-toolbar-title>
      </template>
    </navbar>

    <!-- HEADER -->

    <v-main class="pt-0">
      <v-container fluid class="my-3">
        <div transition="slide-x-reverse-transition">
          <v-container fluid>
            <v-card>
              <v-card-title>
                <v-layout wrap>
                  <v-flex 
                    xs12 
                    px-3 
                    pt-3
                  >
                    <div class="title" style="word-break: break-word">
                       
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text class="mt-3 px-3" style="margin-bottom:110px;">
                <div v-if="loading">
                  <v-layout wrap>
                    <v-flex 
                      xs12 
                      text-sm-right 
                      py-3
                    >
                      <v-skeleton-loader type="card" />
                    </v-flex>
                  </v-layout>
                </div>
                <v-alert 
                    v-else-if="alert != ''"
                    :type="typeAlert">
                    {{ alert }}
                </v-alert>
             
              
              
                
                <encuesta v-else :obj-encuesta="objEncuesta" :img-portada="imgPortada" :parametros="parametros" :token-resultado="tokenResultado"></encuesta>
                <v-btn
                 v-if="loading == false && isContestada == true" 
           class="mx-2"
        color="success"
           @click="obtenerEncuestaResultado"
          >
          <v-icon class="mr-2">visibility</v-icon>
          Ver respuestas enviadas
          </v-btn>
            <v-img  v-if="loading == false && isContestada == true" 
                            :src="require('@/assets/agradecimiento.jpg')"
                            alt="logo"
                        />  
              </v-card-text>
            </v-card>

            <v-snackbar
                key="snackbar_encuestapublica"
                v-model="snackbar"
                :bottom="true"
                :multi-line="true"
                :color="snackbarColor"
            >
                {{ snackbarTexto }}
                <v-btn 
                    dark 
                    text 
                    @click="snackbar = false">
                    Cerrar
                </v-btn>
            </v-snackbar>
          </v-container>
        </div>
      </v-container>
    </v-main>    
    <footer class="hidden-sm-and-down" />
  </v-app>
</template>


<script>
import { Navbar, Footer } from '@/components/layout'
import { getEncuesta } from "@/api";

export default {
  name: "EncuestaPublica",
  components: {
    Navbar,
    Footer,
    Encuesta: () =>
      import("../../components/encuesta/Encuesta"),
  },
  props: {
    idEncuesta: {
      type: String,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
    tokenResultado: {
      type: String,
      required: false,
      default: ''
    },
    parametros: {
      type: String,
      required: false,
      default: ''
    },
     
  },
  data () {
    return {
      objEncuesta: {},
      imgPortada: null,
      isContestada:false,
      idEncuestaResultado:null,
      tokenRes:null,
      settings: {
        maxScrollbarLength: 60,
      },
      loading: true,
      snackbar: false,
      snackbarTexto: "",
      snackbarColor: "",
      alert: '',
      typeAlert: ''
    };
  },
  computed: {},
  beforeMount () {},
  mounted () {    
    this.obtenerEncuesta();
  },
  methods: {
    async obtenerEncuesta () {
      var self = this;
      self.loading = true;

      /* self.snackbar = false;
      self.snackbarTexto = "";
      self.snackbarColor = ""; */
      self.alert = '';
      self.typeAlert = '';

      try {
        let response = await getEncuesta(self.idEncuesta, self.token, self.tokenResultado, false);

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "True") {
              self.objEncuesta = response.data.data.encuesta;
              if(response.data.data.objPortada != null){
                self.imgPortada = 'data:image/png;base64,' + response.data.data.objPortada.docto;
              }
            }
            else{              
/*               self.snackbarTexto = response.data.message;
              self.snackbarColor = "warning";
              self.snackbar = true; */
              self.alert  = response.data.message;
              self.typeAlert = "warning"
            }
          } else {
        /*     self.snackbarTexto = response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true; */

            self.alert  = response.data.message;
            self.typeAlert = "error"
            console.log("LA ENCUESTA");
            if(response.data.message=="La encuesta ya ha sido contestada."){
            self.isContestada=true;
            self.idEncuestaResultado=response.data.data.idResultadoEncuesta;
            self.tokenRes=response.data.data.tokenResultado;
         }
          }
          self.loading = false;
        } else {          
          /* self.snackbarTexto = "Error de red";
          self.snackbarColor = "error";
          self.snackbar = true; */

          self.alert  = "Error de red";
          self.typeAlert = "error"

          self.loading = false;
        }
      } catch (e) {
        /* self.snackbarTexto = e;
        self.snackbarColor = "error";
        self.snackbar = true; */

        self.alert  = e;
        self.typeAlert = "error"

        self.loading = false;
      }
    },
    async obtenerEncuestaResultado() {
      var self = this;
      self.loading = true;
      self.alert = '';
      self.typeAlert = '';
      console.log(self.idEncuestaResultado, self.tokenRes);
      this.$router.push({
        path: `/EncuestaRespuestas/${this.idEncuestaResultado}/${this.tokenRes}`,         
      });
    },
  },
};
</script>
